import * as Yup from "yup";

export const patientRegistrationSchema = Yup.object().shape({
    //  Patient Details
    marital_status: Yup.string().required("Marital status is required"),

    //  Habits
    // habit_smoking: Yup.string().required("Please select an option"),
    // habit_smoking_duration: Yup.number()
    //     .typeError("Duration must be a number")
    //     .nullable()
    //     .when("habit_smoking", {
    //         is: "yes",
    //         then: (schema) =>
    //             schema
    //                 .required("Duration is required")
    //                 .min(1, "Must be at least 1 month")
    //                 .max(999, "Maximum 3 digits allowed"),
    //     }),

    // habit_smokeless: Yup.string().required("Please select an option"),
    // habit_smokeless_duration: Yup.number()
    //     .typeError("Duration must be a number")
    //     .nullable()
    //     .when("habit_smokeless", {
    //         is: "yes",
    //         then: (schema) =>
    //             schema
    //                 .required("Duration is required")
    //                 .min(1, "Must be at least 1 month")
    //                 .max(999, "Maximum 3 digits allowed"),
    //     }),

    // habit_betelnut_with_tobacco: Yup.string().required("Please select an option"),
    // habit_betelnut_with_tobacco_duration: Yup.number()
    //     .typeError("Duration must be a number")
    //     .nullable()
    //     .when("habit_betelnut_with_tobacco", {
    //         is: "yes",
    //         then: (schema) =>
    //             schema
    //                 .required("Duration is required")
    //                 .min(1, "Must be at least 1 month")
    //                 .max(999, "Maximum 3 digits allowed"),
    //     }),

    // habit_alcohol: Yup.string().required("Please select an option"),
    // habit_alcohol_duration: Yup.number()
    //     .typeError("Duration must be a number")
    //     .nullable()
    //     .when("habit_alcohol", {
    //         is: "yes",
    //         then: (schema) =>
    //             schema
    //                 .required("Duration is required")
    //                 .min(1, "Must be at least 1 month")
    //                 .max(999, "Maximum 3 digits allowed"),
    //     }),

    // //  Comorbidities
    // como_diabetes: Yup.string().required("Please select an option"),
    // como_diabetes_duration: Yup.number()
    //     .typeError("Duration must be a number")
    //     .nullable()
    //     .when("como_diabetes", {
    //         is: "yes",
    //         then: (schema) =>
    //             schema
    //                 .required("Duration is required")
    //                 .min(1, "Must be at least 1 month")
    //                 .max(999, "Maximum 3 digits allowed"),
    //     }),

    // como_hypertension: Yup.string().required("Please select an option"),
    // como_hypertension_duration: Yup.number()
    //     .typeError("Duration must be a number")
    //     .nullable()
    //     .when("como_hypertension", {
    //         is: "yes",
    //         then: (schema) =>
    //             schema
    //                 .required("Duration is required")
    //                 .min(1, "Must be at least 1 month")
    //                 .max(999, "Maximum 3 digits allowed"),
    //     }),

    // como_ischemic_heart_disease: Yup.string().required("Please select an option"),
    // como_ischemic_heart_disease_duration: Yup.number()
    //     .typeError("Duration must be a number")
    //     .nullable()
    //     .when("como_ischemic_heart_disease", {
    //         is: "yes",
    //         then: (schema) =>
    //             schema
    //                 .required("Duration is required")
    //                 .min(1, "Must be at least 1 month")
    //                 .max(999, "Maximum 3 digits allowed"),
    //     }),

    // como_asthma_copd: Yup.string().required("Please select an option"),
    // como_asthma_copd_duration: Yup.number()
    //     .typeError("Duration must be a number")
    //     .nullable()
    //     .when("como_asthma_copd", {
    //         is: "yes",
    //         then: (schema) =>
    //             schema
    //                 .required("Duration is required")
    //                 .min(1, "Must be at least 1 month")
    //                 .max(999, "Maximum 3 digits allowed"),
    //     }),

    // como_stroke: Yup.string().required("Please select an option"),
    // como_stroke_duration: Yup.number()
    //     .typeError("Duration must be a number")
    //     .nullable()
    //     .when("como_stroke", {
    //         is: "yes",
    //         then: (schema) =>
    //             schema
    //                 .required("Duration is required")
    //                 .min(1, "Must be at least 1 month")
    //                 .max(999, "Maximum 3 digits allowed"),
    //     }),

    // como_chronic_hepatitisb: Yup.string().required("Please select an option"),
    // como_chronic_hepatitisb_duration: Yup.number()
    //     .typeError("Duration must be a number")
    //     .nullable()
    //     .when("como_chronic_hepatitisb", {
    //         is: "yes",
    //         then: (schema) =>
    //             schema
    //                 .required("Duration is required")
    //                 .min(1, "Must be at least 1 month")
    //                 .max(999, "Maximum 3 digits allowed"),
    //     }),

    // como_msald: Yup.string().required("Please select an option"),
    // como_msald_duration: Yup.number()
    //     .typeError("Duration must be a number")
    //     .nullable()
    //     .when("como_msald", {
    //         is: "yes",
    //         then: (schema) =>
    //             schema
    //                 .required("Duration is required")
    //                 .min(1, "Must be at least 1 month")
    //                 .max(999, "Maximum 3 digits allowed"),
    //     }),

    // como_hiv_aids: Yup.string().required("Please select an option"),
    // como_hiv_aids_duration: Yup.number()
    //     .typeError("Duration must be a number")
    //     .nullable()
    //     .when("como_hiv_aids", {
    //         is: "yes",
    //         then: (schema) =>
    //             schema
    //                 .required("Duration is required")
    //                 .min(1, "Must be at least 1 month")
    //                 .max(999, "Maximum 3 digits allowed"),
    //     }),

    // como_hypothyroidism: Yup.string().required("Please select an option"),
    // como_hypothyroidism_duration: Yup.number()
    //     .typeError("Duration must be a number")
    //     .nullable()
    //     .when("como_hypothyroidism", {
    //         is: "yes",
    //         then: (schema) =>
    //             schema
    //                 .required("Duration is required")
    //                 .min(1, "Must be at least 1 month")
    //                 .max(999, "Maximum 3 digits allowed"),
    //     }),

    // como_others: Yup.string().required("Please select an option"),
    // como_others_duration: Yup.number()
    //     .typeError("Duration must be a number")
    //     .nullable()
    //     .when("como_others", {
    //         is: "yes",
    //         then: (schema) =>
    //             schema
    //                 .required("Duration is required")
    //                 .min(1, "Must be at least 1 month")
    //                 .max(999, "Maximum 3 digits allowed"),
    //     }),

    // //  Family Cancer History
    // history_family_cancer: Yup.string().required("Please select an option"),
    // history_site_of_tumor: Yup.string().when("history_family_cancer", {
    //     is: "yes",
    //     then: (schema) => schema.required("Site of tumor is required"),
    // }),
    // history_relation: Yup.string().when("history_family_cancer", {
    //     is: "yes",
    //     then: (schema) => schema.required("Relation is required"),
    // }),
    // history_specify_relation: Yup.string().when(
    //     ["history_family_cancer", "history_relation"],
    //     {
    //         is: (familyCancer, relation) =>
    //             familyCancer === "yes" && relation === "Other",
    //         then: (schema) => schema.required("Please specify the relation"),
    //     }
    // ),
});
